import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import { Icon, TextHtml } from 'ui';
//import TextEditor from '../compositions/wysiwyg/TextEditor';

function TeacherNotesView({ t, text }) {
  return (
    <div className="teacher-notes">
      <div className="teacher-notes__wrapper">
        {
          <div className="teacher-notes__editor">
            <div className="teacher-notes__editor-header">
              <div className="teacher-notes__editor-header-left">
                <Icon name="teacher" size="xxl" color="primary" />
                <div className="teacher-notes__editor-header-title">{t('Notes for teachers')}</div>
              </div>
              <div className="teacher-notes__editor-header-right"></div>
            </div>
            <div className="teacher-notes__editor-wrapper teacher-notes__editor-wrapper--overflow">
              {/*<TextEditor model={text} disabled={true} />*/}
              {<TextHtml text={text} className="teacher-notes__viewer" />}
            </div>
          </div>
        }
      </div>
    </div>
  );
}

TeacherNotesView.propTypes = {
  t: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
};

export default withTranslation(['common'])(TeacherNotesView);
